export default "__VITE_ASSET__BVWLLVYK__"